import { Box, Stack, Typography } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import { Activitysidebar, Projectquerysidebar, Projectsidebar, ResourcePlannerIcon, SidebarTimesheet, Subprojectsidebar, Tasksidebar } from "../../assets/svgicons";

const MODULE = {
  sub_project: {
    title: "Sub-Project",
    icon: <Subprojectsidebar width={12} height={12} />
  },
  project: {
    title: "Project",
    icon: <Projectsidebar width={12} height={12} />
  },
  project_queries: {
    title: "Project Query",
    icon: <Projectquerysidebar width={12} height={12} />
  },
  resource_planner: {
    title: "Resource Planner",
    icon: <ResourcePlannerIcon width={12} height={12} />
  },
  timesheet: {
    title: "Timesheet",
    icon: <SidebarTimesheet width={12} height={12} />
  },
  activity_qc: {
    title: "Activity/Files",
    icon: <Activitysidebar width={12} height={12} />
  },
  subproject_resource: {
    title: "Sub-Project",
    icon: <Subprojectsidebar width={12} height={12} />
  },
  task: {
    title: "Task",
    icon: <Tasksidebar width={12} height={12} />
  }
};

export const Notification = ({ data }) => {
  const { type, created_at, data: { message } = {} } = data;

  const { title, icon } = MODULE[type] || { title: "Unknown", icon: null };
  const timeAgo = formatDistanceToNow(new Date(created_at), {
    addSuffix: true,
  });

  return (
    <Stack direction="row" spacing={1.5} sx={{ py: 1, px: 2 }}>
      {/* Avatar / Icon Placeholder */}
      {icon && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: 30,
            height: 30,
            borderRadius: 2,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            backgroundColor: "#f5f5f5",
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      )}

      {/* Notification Content */}
      <Stack spacing={0.25}>
        <Typography
          variant="body1"
          sx={{
            fontSize: 12,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {message || "No message"}
        </Typography>

        <Typography variant="caption" sx={{ fontSize: 10, color: "#9C9FA6" }}>
          {title} • {timeAgo}
        </Typography>
      </Stack>
    </Stack>
  );
};
